<h2 mat-dialog-title id="gruppe-godta-invitasjon-dialog-tittel">{{ "Godta invitasjon"|translate }}</h2>
@switch (steg()) {
  @case ('laster') {
    <mat-dialog-content class="laster" data-testid="laster">
      <mat-progress-spinner mode="indeterminate" diameter="50"/>
      <p>{{ 'Henter invitasjon'|translate }}</p>
    </mat-dialog-content>
  }
  @case ('sendkode') {
    <mat-dialog-content class="sendkode" data-testid="sendkode">
      <p>
        {{ 'Du har blitt invitert til gruppen'|translate }}
        <br><span class="tittel">{{ invitasjon().gruppeTittel }}</span> {{ 'i'|translate }}
        <span class="organisasjon">{{ invitasjon().gruppeOrganisasjonsnavn }}</span>.
      </p>
      <p>{{ 'For å bekrefte din identitet sender vi deg en engangskode.'|translate }}</p>
      <mat-dialog-actions align="center">
        <button type="button" mat-raised-button color="primary" (click)="sendOtp()" [disabled]="lagrer()" data-testid="send-otp-knapp">
          {{ 'Få tilsendt engangskode'|translate }}
        </button>
        <button type="button" mat-button (click)="avbryt()" [disabled]="lagrer()">
          {{ 'Avbryt'|translate }}
        </button>
      </mat-dialog-actions>
    </mat-dialog-content>
  }
  @case ('oppgikode') {
    <!-- ingen [formGroup] da siden kun inneholder én formControl -->
    <form (ngSubmit)="godtaInvitasjon()">
      <mat-dialog-content class="oppgikode" data-testid="oppgikode">
        <p>{{ 'Skriv så inn den 6-sifrede engangskoden vi har sendt til {maskertNummer}.'|translate:{maskertNummer: otpSendtTil()} }}</p>
        <otp-felt [formControl]="otpKodeSkjema" [ugyldig]="otpValideringFeilet()"/>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <button type="submit" mat-raised-button color="primary" [disabled]="otpKodeSkjema.invalid || lagrer()" data-testid="bekreft-knapp">
          {{ 'Bekreft'|translate }}
        </button>
        <button type="button" mat-button (click)="sendNyOtp()" [disabled]="lagrer()">
          {{ 'Send ny kode'|translate }}
        </button>
        <button type="button" mat-button (click)="avbryt()" [disabled]="lagrer()">
          {{ 'Avbryt'|translate }}
        </button>
      </mat-dialog-actions>
    </form>
  }
  @case ('kvittering') {
    <mat-dialog-content class="kvittering" data-testid="kvittering">
      <p>
        {{ 'Flott, du har nå tilgang til'|translate }}
        <br><span class="tittel">{{ invitasjon().gruppeTittel }}</span> {{ 'i'|translate }}
        <span class="organisasjon">{{ invitasjon().gruppeOrganisasjonsnavn }}</span>.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button type="submit" mat-raised-button color="primary" (click)="lukk()">
        {{ 'Lukk'|translate }}
      </button>
    </mat-dialog-actions>
  }
}
